<template>
  <div class="plane-add-page" :class="{ isiOSX: isiOSX }">
    <!--<van-nav-bar
      :title="pageTitle"
      left-arrow
      @click-left="reBack"
    />-->
    <van-nav-bar @click-left="reBack" :left-text="pageTitle" left-arrow />
    <van-cell-group>
      <van-field
        :error="errorObject.name"
        @focus="focusInput('name')"
        @blur="blurInput('name')"
        v-model="infoObject.name"
        @input="clearNumber($event)"
        required
        clearable
        label="姓名"
        :maxlength="maxLength"
        placeholder="请与证件号保持一致"
      />
      <van-field
        :error="errorObject.IDcard"
        @focus="focusInput('IDcard')"
        @blur="blurInput('IDcard')"
        @click="selectIDcard"
        v-model="infoObject.IDcard"
        required
        clearable
        readonly
        label="证件类型"
        right-icon="arrow"
        placeholder="请选择您的证件类型"
      />
      <van-popup
        v-model="showIdcard"
        round
        position="bottom"
        class="popup-bottom"
      >
        <div class="popup_title">选择证件类型</div>
        <van-radio-group v-model="radio_1">
          <van-cell-group>
            <van-cell
              v-for="item in radioList"
              :key="item.value"
              :title="item.label"
              clickable
              @click="changeStyle(item)"
            >
              <van-radio
                icon-size="14px"
                checked-color="#FEAC7A"
                slot="right-icon"
                :name="item.value"
              />
            </van-cell>
          </van-cell-group>
        </van-radio-group>

        <van-button type="primary" size="large" @click="close('IDcard')"
          >关闭</van-button
        >
      </van-popup>
      <van-field
        :error="errorObject.id_number"
        @focus="focusInput('id_number')"
        @blur="blurInput('id_number')"
        @input="changeVal()"
        v-if="infoObject.IDcard != undefined"
        type="text"
        class="noName"
        v-model="infoObject.id_number"
        :maxlength="maxLength_1"
        clearable
        label
        :placeholder="radio1.placeholder"
      />
      <!-- <van-field
        @focus="focusInput('last_name')"
        @blur="blurInput('last_name')"
        class="noName"
        v-model="infoObject.last_name"
        clearable
        label="英文姓"
        placeholder="请输入英文姓"
      />
      <van-field
        @focus="focusInput('first_name')"
        @blur="blurInput('first_name')"
        v-model="infoObject.first_name"
        class="noName"
        clearable
        label="英文名"
        placeholder="请输入英文名"
      /> -->
      <van-field
        :error="errorObject.phone"
        @focus="focusInput('phone')"
        @blur="blurInput('phone')"
        class="phone-number"
        v-model="infoObject.phone"
        type="number"
        maxlength="11"
        required
        clearable
        label="手机号"
        placeholder="请填写手机号"
      />
      <div class="number-s">
        <van-dropdown-menu class="number-select">
          <van-dropdown-item v-model="value" :options="option" />
        </van-dropdown-menu>
      </div>
      <van-field
        :error="errorObject.birthday"
        @focus="focusInput('birthday')"
        @blur="blurInput('birthday')"
        @click="showDate"
        v-model="infoObject.birthday"
        required
        clearable
        readonly
        label="出生日期"
        placeholder="请输入出生日期"
      />
      <van-popup v-model="showdate" position="bottom">
        <van-datetime-picker
          @cancel="cancel"
          @confirm="confirm($event, 'birthday')"
          :formatter="formatter"
          v-model="currentDate"
          type="date"
          :min-date="minDate"
        />
      </van-popup>
      <div class="sex-select">
        <div class="sex">
          <span>性别</span>
        </div>
        <van-radio-group v-model="radio2">
          <van-radio
            @click="sexChange(sexItem)"
            v-for="sexItem in radio2List"
            checked-color="#FEAC7A"
            icon-size="16px"
            :name="sexItem.value"
            :key="sexItem.sex"
            >{{ sexItem.sex }}</van-radio
          >
        </van-radio-group>
      </div>
      <div v-if="sexInfo" class="select_p">
        <span>请选择性别</span>
      </div>
      <div class="sex-select space-right">
        <div class="sex">设置为本人</div>
        <van-switch
          @change="changeInfo($event)"
          active-color="#EFA2A2"
          size="14px"
          v-model="checked"
        />
      </div>
    </van-cell-group>
    <div class="tips">
      <p>
        为了保证您的顺利出行，请填写真实的证件信息，旅行日期至少比证件有效期早6个月。
      </p>
      <p>
        根据航空公司要求，购买机票需提交乘机人身份证件信息，并在乘机时出具对应身份证件用于验证，请确保录入信息真实有效。乘机时出具对应身份证件用于验证，销巴生活将通过加密等方式保护您录入的身份证件信息，且在具体订票过程中授权提供给您提供服务的产品供应商、承运人、机票分销系统服务商。
      </p>
    </div>
    <div class="btn-bottom">
      <van-button @click="saveInfo(infoObject)" type="default" size="large"
        >保存</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "+86",
      option: [
        { text: "+86", value: "+86" },
        { text: "+852", value: "+852" },
        { text: "+853", value: "+853" },
        { text: "+886", value: "+886" },
      ],
      infoObject: {
        name: "", //姓名
        IDcard: undefined, //身份证or出生证明
        id_type: undefined, //证件类型编号
        id_number: "", //证件号码
        // last_name: "", //英文姓
        // first_name: "", //英文名
        phone: "", //手机号
        birthday: "", //生日
        gender: "",
        is_me: -1,
      },
      radioList: [
        {
          label: "身份证",
          value: 1,
          placeholder: "请输入您的身份证号码",
        },
        {
          label: "出生证明",
          value: 10,
          placeholder: "可用出生日期代替，如20190101",
        },
      ],
      radio2List: [
        {
          sex: "男",
          value: 1,
        },
        {
          sex: "女",
          value: 2,
        },
      ],
      errorObject: {
        name: false,
        IDcard: false,
        id_number: false,
        phone: false,
        birthday: false,
      },
      showIdcard: false,
      showdate: false,
      radio1: {},
      radio_1: undefined,
      radio2: undefined,
      currentDate: new Date(),
      minDate: new Date(1920, 0, 1),
      checked: false,
      is_me: undefined,
      sexInfo: false,
      isiOSX: false,
      pageTitle: "",
      maxLength: 20,
      maxLength_1: 18,
    };
  },
  methods: {
    reBack() {
      this.$router.go(-1);
    },
    showDate() {
      this.showdate = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
    },
    confirm(value, item) {
      this.showdate = false;
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      var day = value.getDate();
      this.infoObject.birthday =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      this.errorObject[item] = false;
    },
    cancel() {
      this.showdate = false;
    },
    //获取焦点
    focusInput(item) {
      this.errorObject[item] = false;
    },
    //失去焦点
    blurInput(item) {
      if (this.infoObject[item] == "") {
        this.errorObject[item] = true;
      }
      if (item == "id_number" && this.maxLength_1 == 18) {
        if (!this.checkID(this.infoObject.id_number)) {
          this.$toast("身份证号码不存在！");
        }
      }
    },
    changeVal() {
      this.infoObject.id_number = this.infoObject.id_number.replace(
        /[^\w]/gi,
        ""
      );
    },
    //清除数字
    clearNumber(name) {
      this.infoObject.name = name.replace(/[0-9]/g, "");
      if (/[u4e00-u9fa5]/g.test(name)) {
        //英文
        this.maxLength = 40;
      } else {
        //中文
        this.maxLength = 20;
      }
      //maxLength
      //不允许输入中文
      //    this.infoObject.name = name.replace(/[0-9\w]/g, "");
      //不允许输入英文和字母
      //    this.infoObject.name = name.replace(/[u4e00-u9fa5]/g, "");
    },
    selectIDcard() {
      this.showIdcard = true;
    },
    close(params) {
      this.infoObject.id_number = "";
      this.infoObject.IDcard = this.radio1.label;
      this.infoObject.id_type = this.radio1.value;
      if (this.infoObject.IDcard) {
        this.errorObject[params] = false;
      }
      this.showIdcard = false;
    },
    changeStyle(item) {
      this.radio1 = item;
      this.radio_1 = item.value;
      if (item.value == 1) {
        this.maxLength_1 = 18;
      } else if (item.value == 10) {
        this.maxLength_1 = 8;
      }
    },
    //获取性别信息
    sexChange(parmas) {
      this.infoObject.gender = parmas.value;
    },
    changeInfo(params) {
      if (params) {
        this.infoObject.is_me = 1;
      } else {
        this.infoObject.is_me = -1;
      }
    },
    saveInfo(infoObject) {
      for (let info in this.infoObject) {
        if (this.infoObject[info] == "" || this.infoObject[info] == undefined) {
          this.errorObject[info] = true;
        }
      }
      if (this.infoObject.gender == "") {
        this.sexInfo = true;
      }
      if (
        !(
          this.infoObject.name &&
          this.infoObject.IDcard &&
          this.infoObject.id_number &&
          this.infoObject.phone &&
          this.infoObject.birthday &&
          this.infoObject.gender
        )
      ) {
        return;
      }

      if (
        this.infoObject.id_number.length == 8 &&
        this.infoObject.id_type == 10
      ) {
        var millisecond =
          new Date("2019-01-01").getTime() - new Date("2017-01-01").getTime();
        var idNum =
          this.infoObject.id_number.slice(0, 4) +
          "-" +
          this.infoObject.id_number.slice(4, 6) +
          "-" +
          this.infoObject.id_number.slice(6);
        var times2 = new Date().getTime() - new Date(idNum).getTime();
        //	        this.$toast(new Date("2019-01-01").getTime())
        if (times2 >= millisecond) {
          //大于两岁
          this.$toast("乘机人大于2岁，请录入身份证号码！");
          return;
        } else {
          this.request();
        }
      } else if (
        this.infoObject.id_number.length < 8 ||
        (this.infoObject.id_number.length > 8 && this.infoObject.id_type == 10)
      ) {
        this.$toast("请按标准格式录入婴儿出生日期！");
        return;
      } else {
        if (
          this.infoObject.id_number.length == 18 ||
          this.infoObject.id_number.length == 15
        ) {
          if (!this.checkID(this.infoObject.id_number)) {
            this.$toast("身份证号码不存在！");
          } else {
            this.request();
          }
        } else {
          this.$toast("身份证号码错误！");
        }
      }
    },
    request() {
      if (this.$route.query.id) {
        this.$api
          .post("member/member/guests/update", {
            id: this.$route.query.id,
            name: this.infoObject.name,
            phone: this.infoObject.phone,
            // last_name: this.infoObject.last_name,
            // first_name: this.infoObject.first_name,
            birthday: this.infoObject.birthday,
            id_number: this.infoObject.id_number,
            id_type: this.infoObject.id_type,
            is_me: this.infoObject.is_me,
            gender: this.infoObject.gender,
          })
          .then((res) => {
            this.finish();
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } else {
        this.$api
          .post("/member/member/guests/create", {
            phone: this.infoObject.phone,
            // last_name: this.infoObject.last_name,
            // first_name: this.infoObject.first_name,
            birthday: this.infoObject.birthday,
            id_number: this.infoObject.id_number,
            id_type: this.infoObject.id_type,
            is_me: this.infoObject.is_me,
            gender: this.infoObject.gender,
            name: this.infoObject.name,
          })
          .then((res) => {
            this.finish();
          });
      }
    },
    finish() {
      this.$router.go(-1);
    },
    perInfo(id) {
      if (id) {
        this.$api
          .get("/member/member/guests/detail", {
            id: id,
          })
          .then((res) => {
            if (res.birthday.length == 8) {
              res.birthday =
                res.birthday.slice(0, 4) +
                "-" +
                res.birthday.slice(4, 6) +
                "-" +
                res.birthday.slice(6, 8);
            }
            this.infoObject = res;
            if (this.infoObject.id_type == 1) {
              this.infoObject.IDcard = "身份证";
              this.maxLength_1 = 18;
            }
            if (this.infoObject.id_type == 10) {
              this.infoObject.IDcard = "出生证明";
              this.maxLength_1 = 8;
            }
            if (this.infoObject.gender == 1) {
              this.radio2 = 1;
            }
            if (this.infoObject.gender == 2) {
              this.radio2 = 2;
            }
            if (this.infoObject.is_me == 1) {
              this.is_me = 1;
              this.checked = true;
            }
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      }
    },
    checkDate(val) {
      var pattern =
        /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
      if (pattern.test(val)) {
        var year = val.substring(0, 4);
        var month = val.substring(4, 6);
        var date = val.substring(6, 8);
        var date2 = new Date(year + "-" + month + "-" + date);
        if (date2 && date2.getMonth() == parseInt(month) - 1) {
          return true;
        }
      }
      return false;
    },
    checkProv(val) {
      var pattern = /^[1-9][0-9]/;
      var provs = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
      };
      if (pattern.test(val)) {
        if (provs[val]) {
          return true;
        }
      }
      return false;
    },
    checkCode(val) {
      var p =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      var code = val.substring(17);
      if (p.test(val)) {
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += val[i] * factor[i];
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true;
        }
      }
      return false;
    },
    checkID(val) {
      if (this.checkCode(val)) {
        var date = val.substring(6, 14);
        if (this.checkDate(date)) {
          if (this.checkProv(val.substring(0, 2))) {
            return true;
          }
        }
      }
      return false;
    },
  },
  mounted() {
    //pageTitle
    if (this.$route.query.id == undefined) {
      this.pageTitle = "添加旅客信息";
    } else {
      this.pageTitle = "编辑旅客信息";
    }
    this.isiOSX = this.isIphoneX();
    this.perInfo(this.$route.query.id);
  },
};
</script>


<style lang="less">
.plane {
  &-add-page {
    height: 100%;
    background: #f2f2f2;
    .van-nav-bar {
      padding-top: 24px;
      position: fixed;
      top: 0;
      width: 100%;
      background: #f2f2f2;
      .van-nav-bar__left {
        .van-icon-arrow-left:before {
          display: none;
        }
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
        .van-nav-bar__text {
          font-size: 18px;
          color: #333;
          font-weight: 500;
          padding: 0 0 0 31px;
          margin: 0;
        }
      }
      .van-nav-bar__right {
        .van-nav-bar__text {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }
    }
    .van-cell-group {
      padding: 70px 11px 0;
      .van-cell--required::before {
        display: none;
      }

      .van-cell {
        font-size: 13px;
        color: #333;
        line-height: 32px;
        padding: 10px 0;
        .van-cell__title {
          span:after {
            content: "*";
            font-size: 13px;
            color: #e6212f;
            padding-left: 5px;
          }
        }
      }
      .noName {
        span:after {
          display: none;
        }
      }
      .phone-number {
        .van-field__label {
          width: 138px;
        }
      }
      .number-s {
        position: relative;
        .van-dropdown-menu {
          width: 60px;
          position: absolute;
          top: -52px;
          left: 70px;
          .van-dropdown-menu__title {
            font-size: 13px;
            color: #333;
          }
        }
        .van-hairline--top-bottom::after {
          border-width: 0;
        }
      }

      .popup-bottom {
        height: 365px;
        padding: 0 11px;
        box-sizing: border-box;
        .van-cell-group {
          padding: 0;
        }
        .popup_title {
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin-top: 14px;
          margin-bottom: 30px;
        }
        .van-cell__title {
          span:after {
            display: none;
          }
        }

        .van-button--large {
          height: 34px;
          background: linear-gradient(
            0deg,
            rgba(255, 96, 89, 1) 0%,
            rgba(254, 172, 122, 1) 100%
          );
          border-radius: 17px;
          border: none;
          line-height: 34px;
          margin-top: 145px;
          span {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
      .sex-select {
        border-bottom: 1px solid #ebedf0;
        height: 51px;
        line-height: 51px;
        display: flex;
        .sex {
          width: 90px;
          font-size: 13px;
          color: #333;
          span:after {
            content: "*";
            font-size: 13px;
            color: #e6212f;
            padding-left: 5px;
          }
        }
        .van-radio-group {
          display: flex;
          .van-radio {
            margin-right: 39px;
            .van-radio__label {
              margin-left: 10px;
              font-size: 13px;
              color: #333;
            }
          }
        }
      }
      .select_p {
        padding-left: 90px;
        line-height: 30px;
        border-bottom: 1px solid #ebedf0;
        span {
          font-size: 13px;
          color: #f44;
        }
      }
      .space-right {
        justify-content: space-between;
        .van-switch {
          top: 20px;
        }
      }
    }
    .tips {
      padding: 0 11px 50px 15px;
      font-size: 11px;
      color: #72748c;
      line-height: 19px;
      margin-top: 15px;
      background: #f2f2f2;
    }
    .btn-bottom {
      position: fixed;
      box-sizing: border-box;
      bottom: 0;
      width: 100%;
      padding: 0 11px;
      background: #f2f2f2;
      .van-button--large {
        color: #fff;
        height: 35px;
        line-height: 35px;
        margin-bottom: 14px;
        background: linear-gradient(
          0deg,
          rgba(255, 96, 89, 1) 0%,
          rgba(254, 172, 122, 1) 100%
        );
        border-radius: 17px;
        span {
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
}
.isiOSX {
  .van-nav-bar {
    padding-top: 44px;
  }
  .van-cell-group {
    padding-top: 90px;
  }
}
</style>



